/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.7.0-nightly.2026.9.24",
    versionName: "0.7.0-nightly.2026.9.24",
    versionChannel: "nightly",
    buildDate: "2026-09-24T00:16:45.477Z",
    commitHash: "89f6e0be3949c6758e4ee8551df94852545d41b7",
};
